export default __webpack_public_path__ + "assets/arrowDown.9c398c47.svg";